import { ICustomizeColumns, IPagination } from "app/types";
import { IFormError } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";

export type updateFiledType =
  | "name"
  | "description"
  | "scrumMasterId"
  | "date"
  | "sendRetrospectiveRequest";

export enum SprintStatus {
  COMPLETED = "Completed",
  ACTIVE = "Active",
  NOT_STARTED = "Not started",
}
export interface ISprintList {
  _id: string;
  createdAt: string;
  updatedAt: string;
  scrumMasterId: string;
  description: string;
  name: string;
  startDate: string;
  endDate: string;
  projectId: string;
  status: SprintStatus;
  commitments: number;
  originalEstimation: number;
  ticketCounts: ISprintsTicketTypeCounts[];
  members: string[];
  completed: number;
  capacity: number;
  sendRetrospectiveRequest: boolean;
}
export interface ISprintsTicketTypeCounts {
  name: string;
  icon: string;
  value: number;
}
export interface ISprintsTicketStatusCounts {
  name: string;
  color: string;
  value: number;
}
export interface ISprints {
  name: IFormError;
  description: string;
  projectId: string;
  scrumMasterId: string;
  sprintMembers: string[];
  startDate: string;
  endDate: string;
  sendRetrospectiveRequest: boolean;
  selectedSprint: string;
}
export const COLUMN_WIDTHS: Record<string, number> = {
  status: 180,
  members: 180,
  description: 450,
  scrumMaster: 250,
  sprintName: 300,
  startEndDates: 250,
  ticketsAmount: 180,
  velocityTracking: 350,
  capacityHours: 180,
};

export interface ISprintFilters {
  statusFilter: string[];
  startDate: string;
  endDate: string;
  search: string;
}

export interface SprintState {
  settingDrawerOpen: boolean;
  mainLoading: boolean;
  list: ISprintList[];
  completedSprintList: ISprintList[];
  customizeHeader: ICustomizeColumns[];
  formData: ISprints;
  loading: boolean;
  buttonLoading: boolean;
  pagination: IPagination;
  filters: ISprintFilters;
  sprintDetailDrawer: boolean;
  selectedSprintId:string;
}
